export default __webpack_public_path__ + "static/media/desktypes.63d9dbf8.jpg";